import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { kaloNuernberg } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const KALO01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen KALONUERNBERG-01",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/KALONUERNBERG-01/KALO_NUERNBERG-1_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2024 - PDF - 135 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* KALONUERNBERG-01",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/KALONUERNBERG-01/KALO_NUERNBERG-1_Basisinformationsblatt.pdf`,
        description: "Stand 08/2024 - PDF - 187 KB",
    },
];

const KALO02DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-KALONUERNBERG-01-01",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-01/KALO_NUERNBERG-2_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2024 - PDF - 131 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-KALONUERNBERG-01-01",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-01/KALO_NUERNBERG-2_Basisinformationsblatt.pdf`,
        description: "Stand 08/2024 - PDF - 177 KB",
    },
];

const KALO03DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-KALONUERNBERG-01-02",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-02/KALO_NUERNBERG-3_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2024 - PDF - 139 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-KALONUERNBERG-01-02",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-02/KALO_NUERNBERG-3_Basisinformationsblatt.pdf`,
        description: "Stand 08/2024 - PDF - 177 KB",
    },
];

const KALO04DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-KALONUERNBERG-01-03",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-03/KALO_NUERNBERG-4_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2024 - PDF - 133 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-KALONUERNBERG-01-03",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-03/KALO_NUERNBERG-4_Basisinformationsblatt.pdf`,
        description: "Stand 08/2024 - PDF - 185 KB",
    },
];

const KALO05DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-KALONUERNBERG-01-04",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-04/KALO_NUERNBERG-5_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2024 - PDF - 135 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-KALONUERNBERG-01-04",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-04/KALO_NUERNBERG-5_Basisinformationsblatt.pdf`,
        description: "Stand 08/2024 - PDF - 187 KB",
    },
];

const KALO06DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-KALONUERNBERG-01-05",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-05/KALO_NUERNBERG-6_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 08/2024 - PDF - 135 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-KALONUERNBERG-01-05",
        path: `${DOCUMENT_HOST}/docs/general/kalo/kalo-nuernberg/CD-PP-KALONUERNBERG-01-05/KALO_NUERNBERG-6_Basisinformationsblatt.pdf`,
        description: "Stand 08/2024 - PDF - 188 KB",
    },
];

const KaloNuernberg = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(kaloNuernberg.title)}</title>
                <meta name="description" content="Kalo Nürnberg GmbH" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/kalo-nuernberg-bg.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <div className="logo-placeholder-img" />
                            {/* <img src={"/images/logo-kalo-nuernberg.png"} alt="" /> */}
                        </div>
                        <p>
                            Ankauf von Grundstücken und grundstücksgleichen Rechten in Nürnberg und Umgebung sowie Verwaltung
                            eigenen Vermögens.
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>Kalo Nürnberg GmbH</h2>
                        <p>Bei der Finanzierung verfolgt die Kalo Nürnberg GmbH eine langfristig ausgerichtete Strategie.</p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={KALO01DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={KALO02DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={KALO03DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={KALO04DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={KALO05DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={KALO06DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:ga@u-asset.com">ga@u-asset.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default KaloNuernberg;
